import { View as NbView } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const View = NbView;

export default addWithConfig(View);
